// Mock data for Supreme Global Freight website

export const navigationLinks = [
  { name: 'Products & Services', href: '#products' },
  { name: 'Industries', href: '#industries' },
  { name: 'Insights', href: '#insights' },
  { name: 'About', href: '#about' },
  { name: 'Support', href: '#support' }
];

export const heroData = {
  title: 'On the road, and at home',
  description: 'Be ready for seamless and reliable LTL and FTL freight deliveries with Supreme Global Freight. From warehouse to linehaul to home delivery, we move your goods across the continent, and across borders.',
  subtitle: 'Learn more about our services to go all the way.',
  primaryButton: 'Contact us',
  secondaryButton: 'Learn More - Specialized LTL',
  features: ['Dedicated', 'White Glove', 'Expedited'],
  backgroundImage: 'https://images.unsplash.com/photo-1597266833335-ccd08f703654?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxmcmVpZ2h0JTIwbG9naXN0aWNzfGVufDB8fHx8MTc3MzI2NDg0OXww&ixlib=rb-4.1.0&q=85'
};

export const alertBanner = {
  title: 'Middle East Situation',
  description: 'Stay up to date with our latest information, links and guidance here.',
  link: 'Read updates'
};

export const infoCards = [
  {
    id: 1,
    title: 'How to get started',
    description: 'Whether you need to find prices, place a booking, submit documents, or track your cargo, our step-by-step guides will help you find your way around.',
    link: 'Get started',
    image: 'https://images.unsplash.com/photo-1768796372362-05c256e61d8c'
  },
  {
    id: 2,
    title: 'Ready to book?',
    description: 'Sign up to book, manage and pay your shipments online, and access a suite of products and services designed to simplify your supply chain.',
    link: 'Register now',
    image: 'https://images.unsplash.com/photo-1762330474636-637ce87b268b'
  },
  {
    id: 3,
    title: 'Become a logistics expert',
    description: 'Discover insights, introductory videos, explanatory articles and gain the confidence you need to optimise your supply chain.',
    link: 'View all explainers',
    image: 'https://images.unsplash.com/photo-1758691736722-cda1858056e0'
  }
];

export const mainContent = {
  title: 'Be ready for anything to go all the way',
  description: 'Logistics can get messy fast. And just when you think you\'re done, another challenge appears. With Supreme Global Freight as your partner, you don\'t have to face challenges alone. We bring clarity where complexity builds. Whether it\'s one service or a complete solution, you stay ready for what comes next.'
};

export const networkSection = {
  title: 'The Supreme Global East-West Network',
  description: 'With our East-West Network we are setting a new standard for reliability and service quality by reducing port calls on our mainliners, an extensive shuttle network and strategically located hubs delivering world class productivity.',
  link: 'Explore our Network',
  image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800'
};

export const trendSection = {
  title: 'The Logistics Trend Map',
  description: 'When navigating the evolving world of logistics, knowing and acting on the top trends will help you go all the way.',
  link: 'Discover new trends',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800'
};

export const industrySectors = [
  { id: 1, name: 'FMCG', icon: 'Package' },
  { id: 2, name: 'Retail', icon: 'ShoppingCart' },
  { id: 3, name: 'Fashion & Lifestyle', icon: 'Shirt' },
  { id: 4, name: 'Chemicals', icon: 'Beaker' },
  { id: 5, name: 'Perishables', icon: 'Refrigerator' },
  { id: 6, name: 'Automotive', icon: 'Car' },
  { id: 7, name: 'Pharma & Healthcare', icon: 'Pill' },
  { id: 8, name: 'Technology', icon: 'Laptop' }
];

export const insights = [
  {
    id: 1,
    category: 'Sustainability',
    title: 'Green shipping practices for 2025',
    excerpt: 'Explore how sustainable logistics is reshaping the industry...',
    date: '2025-01-15',
    image: 'https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=400'
  },
  {
    id: 2,
    category: 'Digitalisation',
    title: 'AI-powered supply chain optimization',
    excerpt: 'How artificial intelligence is transforming logistics operations...',
    date: '2025-01-10',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400'
  },
  {
    id: 3,
    category: 'Growth',
    title: 'Expanding into emerging markets',
    excerpt: 'Strategic approaches to global logistics expansion...',
    date: '2025-01-05',
    image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=400'
  }
];

export const news = [
  {
    id: 1,
    region: 'North America',
    title: 'Supreme Global Freight announces new distribution center',
    date: '2025-03-01',
    excerpt: 'Expanding our North American operations with state-of-the-art facility...'
  },
  {
    id: 2,
    region: 'Asia Pacific',
    title: 'Strategic partnership enhances Asia-Pacific connectivity',
    date: '2025-02-28',
    excerpt: 'New alliance strengthens our position in key Asian markets...'
  },
  {
    id: 3,
    region: 'Europe',
    title: 'European network expansion completed',
    date: '2025-02-25',
    excerpt: 'Successfully integrated 15 new hubs across European markets...'
  }
];

export const footerLinks = {
  products: [
    'Ocean Freight',
    'Air Freight',
    'Ground Freight',
    'Customs Services',
    'Warehousing',
    'Supply Chain Management'
  ],
  support: [
    'Track Shipment',
    'Documentation',
    'FAQ',
    'Contact Us',
    'Customer Service',
    'Report Issue'
  ],
  company: [
    'About Us',
    'Careers',
    'Press',
    'Sustainability',
    'Investors',
    'Leadership'
  ],
  legal: [
    'Terms & Conditions',
    'Privacy Policy',
    'Cookie Policy',
    'Legal Notice'
  ]
};